import React from "react";
// import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeeStatsCards.css";
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const EmployeeStatsCards = ({ stats, loading }) => {
    const cards = [
        {
            title: "Employees",
            value: loading ? "—" : stats?.total ?? 0,
            icon: "👥",
            color: "#2563eb", },
        {
            title: "Active",
            value: loading ? "—" : stats?.active ?? 0,
            icon: "🟢",
            color: "#16a34a", },
        {
            title: "Inactive",
            value: loading ? "—" : stats?.inactive ?? 0,
            icon: "⚫",
            color: "#64748b", }
    ];

    return (
        // <div className="employee-stats-grid">
        //     {stats.map((card) => (
        //         <div
        //             key={card.title}
        //             className="employee-stat-card"
        //         >
        //             <div
        //                 className="employee-stat-icon"
        //                 style={{
        //                     background:`${card.color}15`,
        //                     color:card.color
        //                 }}
        //             >
        //                 {card.icon}
        //             </div>

        //             <div className="employee-stat-info">
        //                 <div className="employee-stat-value">
        //                     {card.value}
        //                 </div>

        //                 <div className="employee-stat-title">
        //                     {card.title}
        //                 </div>
        //             </div>
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards }/>
    );
};

export default EmployeeStatsCards;
